import React from "react";
import PropTypes from "prop-types";
import { escapeRegExp } from "lodash";

const disambiguateToStyledSubstrings = (text, substring) => {
  const splitText = text.split(
    new RegExp(`(${escapeRegExp(substring)})`, "ig")
  );
  return splitText.map(str => ({
    substring: str,
    isStyledSubstring: str.toLowerCase() === substring.toLowerCase()
  }));
};

const StyledSubstring = ({
  text = "",
  substring = "",
  className = "",
  Component = null
}) => {
  const idx = text.toLowerCase().lastIndexOf(substring.toLowerCase());
  if (idx === -1) return <span>{text}</span>;
  const disambiguatedText = disambiguateToStyledSubstrings(text, substring);
  return (
    <span>
      {disambiguatedText.map((part, index) => {
        if (part.isStyledSubstring) {
          return (
            <span key={index} className={className}>
              {part.substring}
            </span>
          );
        } else {
          return <span key={index}>{part.substring}</span>;
        }
      })}
      {Component}
    </span>
  );
};

StyledSubstring.propTypes = {
  text: PropTypes.string,
  substring: PropTypes.string,
  className: PropTypes.string,
  Component: PropTypes.element
};

export default StyledSubstring;
